import { Injectable, Injector } from '@angular/core';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ImportSdk extends SdkBase {

	constructor(injector: Injector) {
		super(injector);
	}

	public importDocNotes(params: ImportParams): Observable<void> {
		if (params?.file) {
			const formData = new FormData();
			formData.append('File', params.file, params.file.name);
			formData.append('FileType', `.${params.file.name.split('.').pop()}`);
			return this.makeHttpRequest('post', 'api2/import/docnotes', formData);
		}
		return of(null);
	}

	public importFacts(params: ImportParams): Observable<void> {
		if (params?.file) {
			const formData = new FormData();
			formData.append('File', params.file, params.file.name);
			formData.append('FileType', `.${params.file.name.split('.').pop()}`);
			return this.makeHttpRequest('post', 'api2/import/facts', formData);
		}
		return of(null);
	}

	public importContacts(formData: FormData) {
		return this.makeHttpRequest('post', 'api2/import/contacts', formData);
	}

	public importCustodian(formData: FormData) {
		return this.makeHttpRequest('post', 'api2/import/custodians', formData);
	}
}

interface ImportParams {
	file: File;
}
